import { Box, Typography } from '@mui/material'
import { C1CircularProgress } from 'c1ui/components/C1CircularProgress/C1CircularProgress'
import { spacing } from 'c1ui/theme/C1Spacing'
import { RendererProps, resolveDynamicBool, resolveDynamicString } from 'components/a2ui/types'
import { getByPointer } from 'lib/a2ui/resolver'
import { FC } from 'react'

type C1StatusIndicatorRendererProps = Pick<RendererProps, 'component' | 'dataModel'>

/**
 * Renders a status indicator with optional spinner and message.
 * Used to show loading or processing states.
 */
export const C1StatusIndicatorRenderer: FC<C1StatusIndicatorRendererProps> = ({ component, dataModel }) => {
    if (component.component.oneofKind !== 'c1StatusIndicator') return null

    const si = component.component.c1StatusIndicator
    const status = resolveDynamicString(si.status, dataModel, getByPointer)
    const message = resolveDynamicString(si.message, dataModel, getByPointer)
    const showSpinner = resolveDynamicBool(si.showSpinner, dataModel, getByPointer)

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: spacing.s, py: spacing.xs }}>
            {showSpinner && <C1CircularProgress size={16} />}
            <Typography variant="body2" color="text.secondary" fontStyle="italic">
                {message || status}
            </Typography>
        </Box>
    )
}
